module.exports = __webpack_public_path__ + "img/cbib.3166b1c.3166b1c2.png";